'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = getRequestOptions;

var _lodash = require('lodash.pick');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRequestOptions(jsonFetchOptions) {
  var parsedOptions = {};
  parsedOptions.headers = {};

  if (jsonFetchOptions.body !== undefined) {
    parsedOptions.body = (0, _stringify2.default)(jsonFetchOptions.body);
    parsedOptions.headers['Content-Type'] = 'application/json';
  }

  if (jsonFetchOptions.credentials === undefined) {
    parsedOptions.credentials = 'include';
  }

  parsedOptions.headers = (0, _assign2.default)({}, {
    Accept: 'application/json'
  }, jsonFetchOptions.headers, parsedOptions.headers);

  var pickedOptions = (0, _lodash2.default)(jsonFetchOptions, ['body', 'cache', 'credentials', 'headers', 'integrity', 'method', 'mode', 'redirect', 'referrer', 'referrerPolicy']);

  return (0, _assign2.default)({}, pickedOptions, parsedOptions);
}


//////////////////
// WEBPACK FOOTER
// ./~/json-fetch/lib/get_request_options/index.js
// module id = 512
// module chunks = 0